import { render, staticRenderFns } from "./AffiliateCreate.vue?vue&type=template&id=08df14ac&"
import script from "./AffiliateCreate.vue?vue&type=script&lang=js&"
export * from "./AffiliateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports